module.exports = __webpack_public_path__ + "img/Feature.06163efa.png";